import type { ReactNode } from "react"
import { Trans } from "@lingui/react/macro"
import { CheckBox } from "./check-box"

// A multi-select answerer row used by the Assign step and the
// reassign popover/sheet: the AI assistant and each teammate. A
// number is application-level, so several rows can be checked at
// once. The leading square checkbox reflects selection.
export function TeammateRow({
  avatar,
  title,
  subtitle,
  badge,
  selected,
  onSelect,
  testId,
}: {
  avatar: ReactNode
  title: string
  subtitle?: string | null
  badge?: ReactNode
  selected: boolean
  onSelect: () => void
  testId: string
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      role="checkbox"
      aria-checked={selected}
      onClick={onSelect}
      className={`flex items-center gap-3 w-full rounded-xl border px-3 py-3 text-left cursor-pointer transition-colors min-w-0 ${
        selected
          ? "border-[#B86A2D] bg-[#FAF1E6]"
          : "border-[#E5DFD3] bg-background hover:bg-[#FAF6EE]"
      }`}
    >
      <CheckBox selected={selected} />
      {avatar}
      <div className="flex flex-col gap-0.5 grow min-w-0">
        <div className="flex items-center gap-2 min-w-0">
          <span className="font-semibold text-[#1E1B17] text-sm leading-5 truncate">
            {title}
          </span>
          {badge}
        </div>
        {subtitle ? (
          <span className="text-[#7A746B] text-xs leading-4 truncate">
            {subtitle}
          </span>
        ) : null}
      </div>
    </button>
  )
}

export function RecommendedPill() {
  return (
    <span className="shrink-0 rounded-full bg-[#B86A2D] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.04em] text-white">
      <Trans>Recommended</Trans>
    </span>
  )
}
